var selectStore = $('#store_selector');
var mapKey = "AIzaSyARzS-TAaoD0bFE-D86lKJfim5msHg7Gfg";
var clientId = selectStore.data('client-id');
var locale = selectStore.data('locale');


stockStore = {
    init: function () {
        // Setup octipas library
        octipas.setup(clientId, locale);

        $('body').on('product:afterAttributeSelect',function(event,response) {
           selectStore.data('product-id', response.data.product.id);
           stockStore.loadStock();
        });

        // When clicking on the store selector button -> open the store selector iframe
        document.getElementById("store_selector").onclick = function () {
            if ($(".size-field.selected").length > 0) { 
                $('.store-stock p').removeClass('show-message-stockStore');
                octipas.chooseDefaultStore(selectStore.data('product-id'), mapKey).then(function (store) {
                    // If a store has been selected -> load the stocks
                    if (store) {
                        stockStore.loadStock(store);
                    }
                });
            } else {
                $('.store-stock p').addClass('show-message-stockStore');
            }
        };

        // When clicking on the store name -> open the store selector iframe

        document.getElementById("change_store").onclick = function () {

            if ($(".size-field.selected").length > 0) {
                $('.error-message-store').addClass('d-none');
                $('.error-message-store').removeClass('red-message');
                octipas.chooseDefaultStore(selectStore.data('product-id'), mapKey).then(function (store) {
                    // If a store has been selected -> load the stocks
                    if (store) {
                        stockStore.loadStock(store);
                    }
                });
            } else {
                $('.error-message-store').removeClass('d-none');
                $('.error-message-store').addClass('red-message');
            }
        };
        stockStore.loadStock();
    },
    loadStock: function (storeParam) {
        // Colors and label for stock level
        const colors = {

            "in_stock": "#000",
            "limited_stock": "#FFA500",
            "out_of_stock": "#DA3939",

        }
        const labels = {
            "in_stock": selectStore.data('in-stock'),
            "limited_stock": selectStore.data('limited-stock'),
            "out_of_stock": selectStore.data('out-of-stock'),
        }
        const store = storeParam || octipas.getDefaultStore();
        if (!store) {
            // Display the store selector button
            document.getElementById("store-stock-container").style.display = "flex";
        } else {
            if ($(".size-field.selected").length == 0) {
                document.getElementById("store_name").textContent = store.name;
                document.getElementById("store_name").style.display = "inline";
                document.getElementById("store-info").style.display = "flex";
            }else{
                    // Get the stock
                octipas.getProductStock(selectStore.data('product-id'), store.external_id).then(function (stock) {
                    // Show stock and store
                    document.getElementById("store-stock-container").style.display = "none";
                    document.getElementById("error-message-store").style.display = "none";
                    document.getElementById("store_name").textContent = store.name;
                    document.getElementById("store_name").style.display = "inline";
                    document.getElementById("store-info").style.display = "flex";
                    document.getElementById("in_stock_indicator").textContent = labels[stock.stock_level]
                    document.getElementById("in_stock_indicator").style.color = colors[stock.stock_level]
                });
            }
        }

    }
}

module.exports = stockStore;
